import React, { useState } from 'react';
import { http } from '../../lib/http';

const PowerQuoteTab = ({ setMessage, setError }) => {
    const [quote, setQuote] = useState('');
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        if (!quote.trim()) {
            setError('Please enter a quote before saving.');
            return;
        }

        try {
            setSaving(true);
            const response = await http.post('/admin/power-quote', { quote: quote.trim() });
            if (response.data.success) {
                setMessage('Power quote saved successfully! It will be shown to customers.');
                setQuote('');
            } else {
                setError('Failed to save quote. Please try again.');
            }
        } catch (error) {
            console.error('Save Power Quote Error:', error);
            setError(error.response?.data?.message || 'Failed to save power quote.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="space-y-6">
            {/* Header Card */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
                <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-4">
                    <h2 className="text-2xl font-bold text-white">⚡ Power Quote</h2>
                    <p className="text-orange-100 text-sm mt-1">
                        Set a motivational quote that will be displayed to your customers.
                    </p>
                </div>

                <div className="p-6 space-y-4">
                    {/* Quote Input */}
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                            Enter your Power Quote *
                        </label>
                        <textarea
                            value={quote}
                            onChange={(e) => setQuote(e.target.value)}
                            rows={5}
                            maxLength={500}
                            placeholder='e.g. "Success is not given. It is earned — in the gym, in the kitchen, in the mind." 💪'
                            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-orange-500 focus:outline-none resize-none text-gray-800 text-base"
                        />
                        <p className="text-right text-xs text-gray-400 mt-1">{quote.length}/500 characters</p>
                    </div>

                    {/* Preview */}
                    {quote.trim() && (
                        <div className="bg-gradient-to-br from-orange-50 to-orange-100 border-l-4 border-orange-500 rounded-lg p-4">
                            <p className="text-xs font-semibold text-orange-500 uppercase tracking-wide mb-2">Preview</p>
                            <p className="text-gray-800 text-base italic">"{quote.trim()}"</p>
                        </div>
                    )}

                    {/* Save Button */}
                    <button
                        onClick={handleSave}
                        disabled={saving || !quote.trim()}
                        className="w-full sm:w-auto px-8 py-3 bg-orange-500 hover:bg-orange-600 disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold rounded-lg transition-all text-base"
                    >
                        {saving ? 'Saving...' : '⚡ Save Power Quote'}
                    </button>
                </div>
            </div>

        </div>
    );
};

export default PowerQuoteTab;
